import React from 'react'

export const LoaderInBtn = () => {
    return (

        <div className="loader"/>
    )
}